import styles from "./Training.module.css";

const Training = () => {
  return (
    <div>
      <div className="section">
        <div className={styles.trainingContainer}>
          <div className={styles.trainingSection}>
            <div className={styles.trainingMessage}>
              <div className={styles.messageHeading}>
                <h3>
                  <span>WHY APEI?</span>
                </h3>
                <h3>Enhanced Employability</h3>
              </div>
              <div className={styles.messageText}>
                <p>
                  APEI graduates will possess a competitive edge in the job
                  market due to their practical experience and relevant skill
                  set. They should be sought after by employers who value
                  competence and hands-on expertise.
                </p>
              </div>
            </div>
            <div className={styles.trainingCards}>
              <div className={styles.trainingSingleCard}>
                <h3>Industry-Relevant Training</h3>
                <p>
                  APEI works closely with industry professionals and experts to
                  develop our training programs. We prioritise teaching the
                  skills and competencies in high demand in the job market.
                </p>
              </div>
              <div className={styles.trainingSingleCard}>
                <h3>Industry Partnerships</h3>
                <p>
                  We collaborate with leading companies and organisations to
                  provide internship opportunities and industry insights. These
                  partnerships expose our candidates to real work environments
                  and facilitate networking opportunities.
                </p>
              </div>
              <div className={styles.trainingSingleCard}>
                <h3>Practical Training</h3>
                <p>
                  We emphasise hands-on learning and practical experiences.
                  Candidates engage in real-world projects and simulations to
                  develop their problem-solving skills. Community pharmacies and
                  Industry.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Training;
